var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',_vm._g({class:_vm.textColor + '--text',attrs:{"loading":_vm.loading,"color":_vm.color,"disabled":_vm.disabled,"outlined":_vm.outlined,"large":_vm.large,"small":_vm.small,"block":_vm.block,"icon":_vm.icon,"dark":_vm.dark,"text":_vm.text,"fab":_vm.fab,"to":_vm.to}},_vm.listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }